export default __webpack_public_path__ + "static/media/heart.9dbade12.svg";